import CategoryColor from '../store/schema/CategoryColor';

export const DEFAULT_CATEGORY_COLOR_CODE = CategoryColor.GreyDark;
export const DEFAULT_NEW_CATEGORY_COLOR_CODE = CategoryColor.GreyDark;
